import { Autocomplete, styled, AutocompleteProps } from '@mui/material'
import { KeyAndLabelSelectType } from '../../../../types'
import { FC } from 'react'

export const StyledAutocomplete = styled(
  Autocomplete as FC<AutocompleteProps<KeyAndLabelSelectType, true, false, false>>,
)({
  '& .MuiInputBase-root': {
    margin: 0,
    maxWidth: '100%',
  },
  '& .MuiInputLabel-root': {
    maxWidth: 'calc(100% - 40px)',
    minWidth: 'calc(100% - 40px)',
  },
  '& .MuiChip-root.MuiAutocomplete-tag.MuiChip-deletable': {
    borderRadius: '4px',
    backgroundColor: '#F0F0F0',
    '& svg > path': {
      d:
        'path("M9.66732 1.27301L8.72732 0.333008L5.00065 4.05967L1.27398 0.333008L0.333984 1.27301L4.06065 4.99967L0.333984 8.72634L1.27398 9.66634L5.00065 5.93967L8.72732 9.66634L9.66732 8.72634L5.94065 4.99967L9.66732 1.27301Z")',
      fill: 'black',
      fillOpacity: '0.4',
    },
    '& svg': {
      width: 24,
      height: 24,
      margin: '12px 0 0 0',
    },
  },
  '& .MuiInputLabel-formControl': {
    position: 'relative',
  },
})
